import { useQuery } from "urql";

import {
  GetLimitDetailsDocument,
  LimitDetailFilter,
  LimitDetailOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export const useLimitDetails = ({
  filter,
  orderBy,
  page,
}: ApiHookProps<LimitDetailFilter, LimitDetailOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({ query: GetLimitDetailsDocument, variables });
};
